import { AllTrimsResponse, TrimsResponse } from '@gtpl/shared-models/masters';
import { TrimsService } from './trims.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { TrimsDTO } from './dto/trims.dto';
import { TrimsRequest } from './dto/trims.request';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { Trims } from './trims.entity';

@Controller('trims')
export class TrimsController {
    constructor(
        private trimsService: TrimsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
 /**
     * creates  a trims
     * @param TrimsDto Trims DTO
     * @returns  TrimsResponse
     */

  @Post('/createTrims')
  async createTrims(@Body() trimsDTO:TrimsDTO, @Req() request:Request): Promise<TrimsResponse> {
      try {
       return await this.trimsService.createTrims(trimsDTO,false,request);
     } catch (error) {
          return this.applicationExceptionHandler.returnException(TrimsResponse, error);
     }
   }

    /**
     * gets all the Value trims
     * @returns AllTrimsResponse which returns all the Value Trims  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
     @Post('/getAllTrims')
     async getAllTrims(): Promise<AllTrimsResponse> {
         try {
             return await this.trimsService.getAllTrims();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(AllTrimsResponse, error);
         }
     }
 
       /**
      * Activate Or De-Activate Value Trims
      * @param getSingleTrims Trims
      * @returns Value Trims
      */
        @Post('/activateOrDeactivateTrims')
        async activateOrDeactivateTrims(@Body() trimsReq: TrimsRequest): Promise<TrimsResponse> {
            try {
                return await this.trimsService.activateOrDeactivateTrims(trimsReq);
            } catch (err) {
                return this.applicationExceptionHandler.returnException(TrimsResponse, err);
            }
        }
        /**
      *  updates a  value trims
      * @param TrimsDto Trims DTO
      * @returns TrimseResponse
      */
     @Post('/updateTrims')
     async updateTrims(@Body() trimsDTO:TrimsDTO, @Req() request:Request): Promise<TrimsResponse> {
         try {
          return await this.trimsService.createTrims(trimsDTO,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(TrimsResponse, error);
        }
        
      }


      @Post('/getAllTrimsDropDown')
      async getAllTrimsDropDown():Promise<CommonResponse>{
         try {
             return await this.trimsService.getAllTrimsDropDown();
         } catch (err) {
             return this.applicationExceptionHandler.returnException(CommonResponse, err);
         }
      }
 
     
 
      @Post('/getTrimsInfoById')
      async getTrimsById(@Body() trimsReq: TrimsRequest):Promise<Trims>{
         try {
             return await this.trimsService.getTrimsById(trimsReq.trimsId);
         } catch (err) {
            return err;
         }
       }
       
       @Post('/getTrimsInfoById')
     async getTrimsInfoById(@Body() trimsReq: TrimsRequest):Promise<CommonResponse>{
        try {
            return await this.trimsService.getTrimsInfoById(trimsReq.trimsId);
        } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
      }
     
      
}
